import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";

// Import Swiper's fade effect styles
import "swiper/css/effect-fade";

const initializeFactoriesCarousels = () => {
  const carousels = document.querySelectorAll(".fs-description-swiper");

  if (!carousels.length) {
    return;
  }

  carousels.forEach((carousel) => {
    new Swiper(carousel, {
      modules: [Autoplay, EffectFade],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      allowTouchMove: false, // Disable manual sliding
      speed: 800, // Slower fade transition
    });
  });
};

document.addEventListener("DOMContentLoaded", initializeFactoriesCarousels);

// Also run if the page is already loaded (useful for some edge cases)
if (document.readyState !== "loading") {
  initializeFactoriesCarousels();
}
